/* eslint-disable react/jsx-no-target-blank */
import enLanguage from '@assets/images/language-en.png';
import faLanguage from '@assets/images/language-fa.svg';
import { Locale, Path } from "@common/constans";
import { IMenuItem } from "@common/models/CMS/MenuItems";
import Accordion from '@components/general/Accordion';
import Icon from '@components/general/Icon';
import { Culture } from '@core/index';
import Translate from '@service/Translate';
import { formatToDateTime } from '@utilize/Format';
import { loadLocale } from '@utilize/Init';
import { FC, useState } from 'react';
import { useHistory } from 'react-router';
import { Link } from "react-router-dom";
import Label from './general/Label';

interface IFooterProps {
    menuItem: IMenuItem;
    socialNetworks?: IMenuItem;
}

const Footer: FC<IFooterProps> = ({ menuItem, socialNetworks }) => {
    const { tr, re } = Translate;
    const { location } = useHistory();
    const { lang } = Culture.getLocale();
    const IrLocale = Culture.getLocale(Locale.fa);
    const UsLocale = Culture.getLocale(Locale.en);
    const dataTime = Culture.getDateTimeInstance();
    const [indexState, setIndexState] = useState<[number, number]>([-1, -1]);
    const menuItems = menuItem.menuItemsList?.menuItems;

    const renderedMenuItems = menuItems?.map((item, parentIndex) =>
        <nav
            key={item.contentItemId}
            className={`sub-menu-item-container col-1-${(menuItems?.length || 0) + 1} col-sm-1-1`}
        >
            <Accordion title={item.displayText}>
                <ul className="sup-menu-items">
                    {
                        item.menuItemsList?.menuItems.map((item, index) => {
                            return (
                                item.linkMenuItem?.url ?
                                    <li key={`sup_menu_item_${index}`}>
                                        {
                                            item.externalLink ?
                                                <a
                                                    href={item.linkMenuItem?.url}
                                                    className={`external-link ${(parentIndex === indexState[0] && index === indexState[1]) ? "sub-link-footer active" : "sub-link-footer"}`}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    <Label
                                                        text={item.displayText || ""}
                                                        icon="icon-external-link"
                                                        order='text-icon'
                                                        mode='inline'
                                                    />
                                                </a>
                                                :
                                                <Link
                                                    key={item.contentItemId}
                                                    className={(parentIndex === indexState[0] && index === indexState[1]) ? "sub-link-footer active" : "sub-link-footer"}
                                                    to={item.linkMenuItem.url}
                                                    onClick={() => setIndexState([parentIndex, index])}
                                                >
                                                    {item.linkMenuItem.name}
                                                </Link>
                                        }
                                    </li>
                                    :
                                    <li
                                        key={item.contentItemId}
                                        className="sub-link-footer"
                                    >
                                        {item.displayText}
                                    </li>
                            )
                        })
                    }
                </ul>
            </Accordion>
        </nav>
    )

    return (
        <footer id="footer" className="footer">
            <div className="container">
                <div className="row first-section spa-1">
                    {renderedMenuItems}
                    <div className={`col-1-${(menuItems?.length || 0) + 1} col-sm-1-1 footer-item-container`}>
                        <div className="logo-wrapper flex column-direction flex-end">
                            <Icon className="logo" name="icon-mahan-air-logo" />
                            <a
                                className="e-namad"
                                target="_blank"
                                referrerPolicy="origin"
                                href="https://trustseal.enamad.ir/?id=588065&Code=fOZSb2SNqZdL9csUDG5XufDGO1ZH9V9z"
                            >
                                <img
                                    id="fOZSb2SNqZdL9csUDG5XufDGO1ZH9V9z"
                                    src="https://trustseal.enamad.ir/logo.aspx?id=588065&Code=fOZSb2SNqZdL9csUDG5XufDGO1ZH9V9z"
                                    referrerPolicy="origin"
                                    alt={tr("e_namad")}
                                    width={60}
                                    height={60}
                                />
                            </a>
                        </div>
                        <div className='language-wrapper'>
                            <div className="language">
                                <span>{tr("footer_language")}</span>
                                <div className="icons">
                                    <div className={`circle ${lang === "fa" ? " default" : ""}`} onClick={() => loadLocale(IrLocale.code, true, location.pathname + location.search)}>
                                        <img src={faLanguage} alt="fa-language" />
                                    </div>
                                    <div className={`circle ${lang === "en" ? " default" : ""}`} onClick={() => loadLocale(UsLocale.code, true, location.pathname + location.search)}>
                                        <img src={enLanguage} alt="en-language" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row third-section spa-0">
                    <div className="col-1-3 rights">
                        {re("footer_rights", <span className='ltr'>{`© ${formatToDateTime(dataTime.getTime(), { format: "Y", locale: Locale.en })}`}</span>)}
                    </div>
                    <div className="col-1-3 social-networks">
                        {
                            socialNetworks?.menuItemsList?.menuItems.map(menuItem =>
                                <a
                                    key={menuItem.contentItemId}
                                    href={menuItem.linkMenuItem?.url}
                                    target="_blank"
                                    rel="noopener noreferrer">
                                    <Icon name={`icon-${menuItem.displayText?.toLocaleLowerCase()}`} />
                                </a>
                            )
                        }
                    </div>
                    <div className="col-1-3 privacy-terms">
                        <div className="privacy">
                            <Link to={Path.PrivacyPolicy} >{tr("footer_privacy")}</Link>
                        </div>
                        <div className="terms">
                            <Link to={Path.TermCondition} >{tr("terms_and_conditions")}</Link>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer;